import { watch } from 'vue';
import {
  DARK_SCHEME_QUERY,
  systemPrefersDark,
} from '@features/tenant/colorScheme';
import { useColorSchemeStore } from '@features/tenant/store/colorScheme';
import { useTenantStore } from '@features/tenant/store/tenant';

const deviceSchemeQuery = (win: Window): MediaQueryList | null => {
  try {
    return typeof win.matchMedia === 'function'
      ? win.matchMedia(DARK_SCHEME_QUERY)
      : null;
  } catch {
    return null;
  }
};

export const startColorScheme = (win: Window = window) => {
  const store = useColorSchemeStore();
  store.followSystem(systemPrefersDark(win));

  const query = deviceSchemeQuery(win);
  const onDeviceChange = (event: { matches: boolean }) => {
    store.followSystem(event.matches);
  };
  query?.addEventListener('change', onDeviceChange);

  const stopWatching = watch(
    () => store.scheme,
    () => {
      useTenantStore().applyBranding();
    },
  );

  return () => {
    query?.removeEventListener('change', onDeviceChange);
    stopWatching();
  };
};
